var exports = {
  "Q": "x31de4314--dde4ac--content",
};

module.exports = exports;
